/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { WithdrawalAlternativeItem } from './WithdrawalAlternativeItem';
export type Withdrawal = {
    /**
     * Withdrawal ID
     */
    id?: string;
    /**
     * User ID
     */
    userId?: string;
    /**
     * Array of inventory item IDs
     */
    inventoryItemIds?: Array<string>;
    /**
     * Withdrawal type
     */
    type?: Withdrawal.type;
    /**
     * Initial value of withdrawal
     */
    initialValue?: number;
    /**
     * Current value of withdrawal
     */
    currentValue?: number;
    /**
     * Withdrawal status (0=PENDING, 1=PROCESSING, 2=COMPLETED, 3=CANCELLED)
     */
    status?: Withdrawal.status;
    /**
     * Alternative items if original item unavailable
     */
    alternatives?: Array<WithdrawalAlternativeItem> | null;
    /**
     * When exchange offer expires
     */
    expiresAt?: string | null;
    /**
     * Creation timestamp
     */
    createdAt?: string;
    /**
     * Last update timestamp
     */
    updatedAt?: string;
};
export namespace Withdrawal {
    /**
     * Withdrawal type
     */
    export enum type {
        SHADOWPAY = 'SHADOWPAY',
        GAMEMONEY = 'GAMEMONEY',
    }
    /**
     * Withdrawal status (0=PENDING, 1=PROCESSING, 2=COMPLETED, 3=CANCELLED)
     */
    export enum status {
        '_0' = 0,
        '_1' = 1,
        '_2' = 2,
        '_3' = 3,
    }
}

